import React from 'react'

import SectionDivider from '../../../react4xp/components/SectionDivider'

function SectionDividerPart(props) {
    return (
        <SectionDivider />
    )
}

export default (props) => <SectionDividerPart {...props} />
